import { useEffect, useState } from 'react'
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField
} from '@mui/material'
import { isAnyBlank } from '../../utils/string'
import AsignaturaSelector from '../../components/form/AsignaturaSelector/AsignaturaSelector'
import ProfesorSelector from '../../components/form/ProfesorSelector/ProfesorSelector'
import AcademiaSelector from '../../components/form/AcademiaSelector/AcademiaSelector'
import FechaSelector from '../../components/form/FechaSelector/FechaSelector'
import HorarioSelector from '../../components/form/HorarioSelector/HorarioSelector'
import { dateFromString, dateToDateTime, dateToString } from '../../utils/date'
import css from './ModalEditarAsistencia.module.css'

const ModalEditarAsistencia = ({
  open,
  asistencia,
  onSubmit,
  onClose,
  isLoading
}) => {
  const [datos, setDatos] = useState({
    asignatura: '',
    profesor: '',
    centro: '',
    hora: null,
    fecha: null,
    observaciones: ''
  })

  const [showHorarioWarning, setShowHorarioWarning] = useState(false)

  useEffect(() => {
    setDatos({
      asignatura: '',
      profesor: '',
      centro: '',
      fecha: null,
      hora: null,
      observaciones: ''
    })
    setShowHorarioWarning(false)
  }, [open])

  useEffect(() => {
    if (!asistencia) return
    setDatos({
      asignatura: asistencia.asignaturaId,
      profesor: asistencia.profesorId,
      centro: asistencia.centro,
      fecha: dateToDateTime(dateFromString(asistencia.fecha)),
      hora: asistencia.hora,
      observaciones: asistencia.observaciones
    })
    setShowHorarioWarning(false)
  }, [asistencia])

  const isSubmitDisabled = isAnyBlank(datos.asignatura, datos.centro)

  const handleSubmit = () => {
    onSubmit({
      id: asistencia.id,
      asignatura: datos.asignatura,
      profesor: datos.profesor,
      centro: datos.centro,
      fecha: dateToString(datos.fecha),
      hora: datos.hora,
      observaciones: datos.observaciones
    })
  }

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      <DialogTitle>Editar datos de la clase</DialogTitle>
      <DialogContent className={css.main}>
        <DialogContentText className={css.intro}>
          Puedes modificar los datos de la clase
        </DialogContentText>
        {showHorarioWarning && (
          <Alert className={css.alert} severity='warning'>
            El precio de la contratación puede cambiar si se modifica el
            horario.
          </Alert>
        )}
        <AsignaturaSelector
          className={css.input}
          name='asignatura'
          label='Asignatura'
          value={datos.asignatura}
          onChange={(_e, value) =>
            setDatos({ ...datos, asignatura: value?.id || '' })
          }
        />
        <ProfesorSelector
          className={css.input}
          name='profesor'
          label='Profesor'
          value={datos.profesor}
          onChange={(_e, value) =>
            setDatos({ ...datos, profesor: value?.id || '' })
          }
        />
        <AcademiaSelector
          className={css.input}
          name='academia'
          label='Academia'
          value={datos.centro}
          onChange={e => setDatos({ ...datos, centro: e.target.value })}
        />
        <FechaSelector
          className={css.input}
          label='Fecha'
          value={datos.fecha}
          disablePast
          onChange={value => setDatos({ ...datos, fecha: value })}
          onFocus={() => setShowHorarioWarning(true)}
        />
        <HorarioSelector
          className={css.input}
          name='horario'
          label='Hora'
          centro={datos.centro}
          fecha={datos.fecha}
          value={datos.hora}
          onChange={(_e, value) => setDatos({ ...datos, hora: value })}
          onFocus={() => setShowHorarioWarning(true)}
        />
        <TextField
          className={css.input}
          label='Observaciones'
          value={datos.observaciones}
          onChange={e => setDatos({ ...datos, observaciones: e.target.value })}
          variant='standard'
          multiline
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cancelar
        </Button>
        <Button
          disabled={isSubmitDisabled || isLoading}
          color='primary'
          onClick={handleSubmit}
          startIcon={isLoading && <CircularProgress size={12} />}
        >
          Modificar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalEditarAsistencia
